import { Helmet } from "react-helmet-async";
import { useLang } from "../i18n";

// Title and html lang are managed here (Helmet replaces the single <title>).
// Description, canonical, hreflang and OG/Twitter tags are prerendered into
// each page's static HTML at build time (scripts/prerender.js) — emitting them
// here as well would duplicate them in the rendered DOM (2 canonicals etc).
export function Seo({ title, children }) {
  const { lang } = useLang();
  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{title}</title>
      {children}
    </Helmet>
  );
}
